var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 75,
    viewBox: "0 0 180 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_219)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180 38.7001C180 25.9001 173.8 15.8 161.95 15.8C150.05 15.8 142.85 25.9001 142.85 38.6001C142.85 53.65 151.35 61.25 163.55 61.25C169.5 61.25 174 59.9 177.4 58V48C174 49.7 170.1 50.75 165.15 50.75C160.3 50.75 156 49.0501 155.45 43.1501H179.9C179.9 42.5001 180 39.9001 180 38.7001ZM155.3 33.9501C155.3 28.3001 158.75 25.95 161.9 25.95C164.95 25.95 168.2 28.3001 168.2 33.9501H155.3Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.55 15.8C118.65 15.8 115.5 18.1 113.75 19.7L113.1 16.6H102.1V74.9L114.6 72.25L114.65 58.1C116.45 59.4 119.1 61.25 123.5 61.25C132.45 61.25 140.6 54.05 140.6 38.2001C140.55 23.7001 132.3 15.8 123.55 15.8ZM120.55 50.25C117.6 50.25 115.85 49.2001 114.65 47.9001L114.6 29.35C115.9 27.9 117.7 26.9 120.55 26.9C125.1 26.9 128.25 32 128.25 38.55C128.25 45.25 125.15 50.25 120.55 50.25Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.9 12.85L97.45 10.15V0L84.9 2.65V12.85Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.45 16.6499H84.9V60.4H97.45V16.6499Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.45 20.3499L70.65 16.6499H59.85V60.4H72.35V30.7499C75.3 26.8999 80.3 27.5999 81.85 28.1499V16.6499C80.25 16.0499 74.4 14.9499 71.45 20.3499Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.45 5.80005L34.25 8.40005L34.2 48.4501C34.2 55.85 39.7499 61.3 47.1499 61.3C51.25 61.3 54.25 60.55 55.9 59.65V49.5001C54.3 50.15 46.3999 52.45 46.3999 45.0501V27.3001H55.9V16.65H46.3999L46.45 5.80005Z",
    fill: "#635BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.65 29.3501C12.65 27.4001 14.25 26.65 16.9 26.65C20.7 26.65 25.5 27.8001 29.3 29.8501V18.1C25.15 16.45 21.05 15.8 16.9 15.8C6.75 15.8 0 21.1 0 29.9501C0 43.7501 19 41.5501 19 47.5001C19 49.8001 17 50.55 14.2 50.55C10.05 50.55 4.75 48.8501 0.55 46.5501V58.45C5.2 60.45 9.9 61.3 14.2 61.3C24.6 61.3 31.75 56.15 31.75 47.2001C31.7 32.3001 12.65 34.9501 12.65 29.3501Z",
    fill: "#635BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider1);
export default __webpack_public_path__ + "static/media/slider-1.3a7fba569fba817c4250893b00bf54b9.svg";
export { ForwardRef as ReactComponent };